import React from 'react';
import styles from './BlurColor.module.css';

interface BlurColorProps {
  count: number;
  blur: number;
  zIndex?: number;
}

const getRandomNumber = (min: number, max: number): number => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

// const getRandomColor = () => {
//     const colorType = getRandomNumber(1, 3);
    
//     switch(colorType) {
//         case 1: // Blue variations (32, 147, 255)
//             return `rgba(${getRandomNumber(20, 44)}, ${getRandomNumber(135, 159)}, ${getRandomNumber(243, 255)}, 0.2)`;
//         case 2: // Yellow variations (255, 207, 32)
//             return `rgba(${getRandomNumber(243, 255)}, ${getRandomNumber(195, 219)}, ${getRandomNumber(20, 44)}, 0.2)`;
//         case 3: // Green variations (28, 218, 60)
//             return `rgba(${getRandomNumber(16, 40)}, ${getRandomNumber(206, 230)}, ${getRandomNumber(48, 72)}, 0.2)`;
//         default:
//             return `rgba(32, 147, 255, 0.2)`;
//     }
// };

const getRandomColor = () => {
    const colorType = getRandomNumber(1, 3);
    
    switch(colorType) {
        case 1: // Blue variations (32, 147, 255)
            return `rgba(${getRandomNumber(255, 255)}, ${getRandomNumber(255, 255)}, ${getRandomNumber(255, 255)}, 0)`;
        case 2: // Yellow variations (255, 207, 32)
            return `rgba(${getRandomNumber(255, 255)}, ${getRandomNumber(255, 255)}, ${getRandomNumber(255, 255)}, 0.1)`;
        case 3: // Green variations (28, 218, 60)
            return `rgba(${getRandomNumber(255, 255)}, ${getRandomNumber(255, 255)}, ${getRandomNumber(255, 255)}, 0.1)`;
        default:
            return `rgba(13, 255, 0, 0.2)`;
    }
};
  

const BlurColor: React.FC<BlurColorProps> = ({ count, blur, zIndex }) => {
  const generateRandomElements = () => {
    const elements = [];
    for (let i = 0; i < count; i++) {
      const width = getRandomNumber(300, 400);
      const height = width;//getRandomNumber(30, 100);
      const top = getRandomNumber(0, window.innerHeight - height);
      const left = getRandomNumber(0, window.innerWidth - width);
      
      elements.push(
        <div
            key={i}
            className={styles.blurElement}
            style={{
                top: `${top}px`,
                left: `${left}px`,
                width: `${width}px`,
                height: `${height}px`,
                backgroundColor: getRandomColor(),
            } as React.CSSProperties}
        />
      );
    }
    return elements;
  };

  return (
    <div className={styles.container} style={{
        zIndex: zIndex ? zIndex : 0,
        'filter': `blur(${blur}px)`,
    }}>
      {generateRandomElements()}
    </div>
  );
};

export default BlurColor;

